module.exports = __webpack_public_path__ + "media/images/icons/country_flags/lt-93a07daff68dea7336fd2f400ed2fdd1.svg";